import { filterObject } from "@/utils";

import { MODAL_FILTER_PREFIX } from "./settings";

export const clearPrefixedKeys = (obj: Record<string, unknown>) =>
  filterObject(obj, (k) => !k.startsWith(MODAL_FILTER_PREFIX));
